import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative pt-32 pb-12 bg-brand-dark overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20clean%20minimal%20background%20texture%20light%20pattern%20professional%20website%20privacy%20policy%20legal%20document&width=1920&height=300&seq=privacy1&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative max-w-4xl mx-auto px-4 md:px-6 text-center">
            <div className="flex items-center justify-center gap-2 text-white/50 text-sm font-body mb-4">
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white">Privacy Policy</span>
            </div>
            <h1 className="font-heading font-black text-white text-4xl md:text-5xl mb-3">Privacy Policy</h1>
            <p className="font-body text-white/60 text-sm">Last updated: April 6, 2026</p>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="font-body text-gray-600 text-sm leading-relaxed space-y-8">

              <div className="bg-brand-beige rounded-2xl p-5">
                <p>
                  This Privacy Policy describes how <strong className="text-brand-dark">Adry &amp; Mich Cleaning and Handyman Service</strong> ("we," "us," or "our") collects, uses, and shares information about you when you visit our website or use our services. By using our website, you agree to the collection and use of information in accordance with this policy.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">1. Information We Collect</h2>
                <p className="mb-3">We collect information you provide directly to us, such as when you:</p>
                <ul className="list-disc pl-5 space-y-2 mb-4">
                  <li>Fill out a contact or quote request form</li>
                  <li>Send us an email or call us</li>
                  <li>Subscribe to our newsletter</li>
                  <li>Communicate with us via WhatsApp or social media</li>
                </ul>
                <p className="mb-3">The types of information we may collect include:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li><strong className="text-brand-dark">Personal Identification:</strong> Name, email address, phone number</li>
                  <li><strong className="text-brand-dark">Service Information:</strong> Address of the property to be serviced, preferred service date, type of service requested</li>
                  <li><strong className="text-brand-dark">Communications:</strong> Messages, inquiries, and feedback you send us</li>
                  <li><strong className="text-brand-dark">Technical Data:</strong> IP address, browser type, pages visited, time spent on pages (collected automatically via analytics tools)</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">2. How We Use Your Information</h2>
                <p className="mb-3">We use the information we collect to:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>Respond to your inquiries and provide quotes for our services</li>
                  <li>Schedule and deliver cleaning and handyman services</li>
                  <li>Send you service confirmations, reminders, and follow-ups</li>
                  <li>Send promotional emails and special offers (only if you have opted in)</li>
                  <li>Improve our website and services based on usage data</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">3. How We Share Your Information</h2>
                <p className="mb-3">
                  We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
                </p>
                <ul className="list-disc pl-5 space-y-2">
                  <li><strong className="text-brand-dark">Service Providers:</strong> We may share information with trusted third-party vendors who assist us in operating our website or conducting our business (e.g., email platforms, scheduling tools), subject to confidentiality agreements.</li>
                  <li><strong className="text-brand-dark">Legal Requirements:</strong> We may disclose your information if required by law or in response to valid legal requests by public authorities.</li>
                  <li><strong className="text-brand-dark">Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">4. Data Retention</h2>
                <p>
                  We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When your information is no longer needed, we will securely delete or anonymize it.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">5. Your Rights</h2>
                <p className="mb-3">Depending on your location, you may have the following rights regarding your personal information:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li><strong className="text-brand-dark">Access:</strong> Request a copy of the personal information we hold about you</li>
                  <li><strong className="text-brand-dark">Correction:</strong> Request that we correct inaccurate or incomplete information</li>
                  <li><strong className="text-brand-dark">Deletion:</strong> Request that we delete your personal information</li>
                  <li><strong className="text-brand-dark">Opt-Out:</strong> Unsubscribe from marketing communications at any time</li>
                  <li><strong className="text-brand-dark">Portability:</strong> Request a copy of your data in a portable format</li>
                </ul>
                <p className="mt-3">To exercise any of these rights, please contact us using the information below.</p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">6. Security</h2>
                <p>
                  We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is 100% secure. We cannot guarantee absolute security of your data.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">7. Third-Party Links</h2>
                <p>
                  Our website may contain links to third-party websites (such as Google Maps, WhatsApp, or social media platforms). We are not responsible for the privacy practices of those sites and encourage you to review their privacy policies.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">8. Children&apos;s Privacy</h2>
                <p>
                  Our website is not directed to children under the age of 13. We do not knowingly collect personal information from children. If you believe we have inadvertently collected information from a child, please contact us immediately.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">9. Changes to This Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on this page with an updated date. We encourage you to review this policy periodically.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-bold text-brand-dark text-xl mb-3">10. Contact Us</h2>
                <p className="mb-3">If you have any questions about this Privacy Policy, please contact us:</p>
                <div className="bg-brand-beige rounded-2xl p-5 flex flex-col gap-2">
                  <p className="font-heading font-bold text-brand-dark text-sm">Adry &amp; Mich Cleaning and Handyman Service</p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-map-pin-line text-brand-green"></i>
                    10639 Misty Ln, Royal Palm Beach, FL 33411
                  </p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-phone-line text-brand-green"></i>
                    <a href="tel:+15612626118" className="hover:text-brand-green transition-colors cursor-pointer">(561) 262-6118</a>
                  </p>
                  <p className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-mail-line text-brand-green"></i>
                    <a href="mailto:adrimich7778@hotmail.com" className="hover:text-brand-green transition-colors cursor-pointer">adrimich7778@hotmail.com</a>
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
